import React from 'react'
import { CheckoutPage } from '../../model'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { ArcadeSummaryPage } from '../summary-arcade'
import { BronteSummaryPage } from '../summary-bronte'
import { SummaryNotificationProvider } from '../../component'
import { useIsAppleRetailOrder } from '../../state/checkout/hooks'
import { AppleRetailSummaryPage } from '../summary-apple-retail'
import { useIsConsumerLendingOrder } from '../../state/consumerLending/hooks'
import { PayMonthlySummaryPage } from '../summary-pay-monthly'

export const SummaryPage: CheckoutPage = () => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isAppleRetailOrder = useIsAppleRetailOrder()
  const isConsumerLendingOrder = useIsConsumerLendingOrder()

  let SummaryComponent = BronteSummaryPage

  if (isAppleRetailOrder) {
    SummaryComponent = AppleRetailSummaryPage
  } else if (isConsumerLendingOrder) {
    SummaryComponent = PayMonthlySummaryPage
  } else if (isArcadeDesignLanguage) {
    SummaryComponent = ArcadeSummaryPage
  }

  // TODO: Fix rerender flashing between diff summary component causing Arcade Summary toast to show up during manual page refresh, useIsAppleRetailOrder flag value should cache

  return (
    <SummaryNotificationProvider>
      <SummaryComponent />
    </SummaryNotificationProvider>
  )
}
